export function isMsftDogfood(docUrl) {
    return docUrl
        ? docUrl.lastIndexOf('microsoft-my.sharepoint-df.com') > -1 ||
            docUrl.lastIndexOf('microsoft.sharepoint-df.com') > -1
        : false;
}
//# sourceMappingURL=isMsftDogfood.js.map